import _ from 'lodash';
import { createSelector } from 'reselect';

export const getSelectorBasedStoreValue = createSelector(
  [(state) => state, (state, selectedState) => selectedState],
  (state, selectedState) => {
    return _.get(state, selectedState);
  }
);
